import type {FC} from "react";

import type {StringSetterFunc} from "../wizard.types";

/**
 * Wizard related text form field component.
 */
export const TextFormField: FC<{
  labelText: string,
  testId: string,
  value: string,
  onChange: StringSetterFunc
}> = ({labelText, testId, value, onChange}) =>
  (
    <>
      <label>{labelText}</label>
      <input data-testid={testId} type='text' className='form-control mb-3' name='' placeholder=''
             value={value} onChange={(e) => {
        onChange(e.target.value)
      }}/>
    </>
  )
